// src/components/Navbar.js
import React from "react";
import { Link } from "react-router-dom";
import { Navbar as BSNavbar, Nav, Container, Image } from "react-bootstrap";
import profileImg from "../assets/profile.jpeg";

const Navbar = () => {
  return (
    <BSNavbar bg="dark" variant="dark" expand="lg" sticky="top">
      <Container>
        {/* Left Section: Brand + Profile Icon */}
        <div className="d-flex align-items-center gap-3">
          {/* Profile Image */}
          <Link to="/profile">
            <Image
              src={profileImg}
              roundedCircle
              width={40}
              height={40}
              alt="Profile"
              className="border border-white"
            />
          </Link>

          {/* Brand Text */}
          <BSNavbar.Brand as={Link} to="/">
            My Portfolio
          </BSNavbar.Brand>
        </div>

        {/* Toggle and Collapse for small screens */}
        <BSNavbar.Toggle aria-controls="basic-navbar-nav" />
        <BSNavbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/education">
              Education
            </Nav.Link>
            <Nav.Link as={Link} to="/experience">
              Experience
            </Nav.Link>
            <Nav.Link as={Link} to="/achievement">
              Achievements
            </Nav.Link>
            <Nav.Link as={Link} to="/skills">
              Skills
            </Nav.Link>
            <Nav.Link as={Link} to="/family-tree">
              My Family
            </Nav.Link>
          </Nav>
        </BSNavbar.Collapse>
      </Container>
    </BSNavbar>
  );
};

export default Navbar;
